import React, { useState, useRef, useEffect } from 'react';
import PostStatusBadge from './PostStatusBadge';

const STATUSES = [
  { value: 'draft', label: 'Rascunho' },
  { value: 'em_producao', label: 'Em Producao' },
  { value: 'aprovado', label: 'Aprovado' },
  { value: 'publicado', label: 'Publicado' },
];

function PostStatusDropdown({ status, onChangeStatus, disabled }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleSelect = async (newStatus) => {
    setOpen(false);
    if (newStatus !== status && onChangeStatus) {
      await onChangeStatus(newStatus);
    }
  };

  return (
    <div className="status-dropdown" ref={ref}>
      <button
        className="btn-icon"
        onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
        disabled={disabled}
        title="Alterar status"
      >
        <PostStatusBadge status={status} />
      </button>
      {open && (
        <div className="status-dropdown-menu">
          {STATUSES.map(s => (
            <button
              key={s.value}
              className={`status-dropdown-item ${s.value === status ? 'active' : ''}`}
              onClick={(e) => { e.stopPropagation(); handleSelect(s.value); }}
            >
              {s.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default PostStatusDropdown;
